import { SocialType } from "shared/SocialsShare/SocialsShare";
import React, { FC } from "react";

export interface SocialsListProps {
  className?: string;
  itemClass?: string;
  socials?: SocialType[];
  showLabel?: boolean;
  labelClassName?: string;
}

const socialsDemo: SocialType[] = [
  { name: "Facebook", icon: "lab la-facebook-square", href: "https://www.facebook.com/tribyouplace" },
  { name: "LinkedIn", icon: "lab la-linkedin", href: "https://www.linkedin.com/company/tribyou-places/" },
  { name: "Instagram", icon: "lab la-instagram", href: "https://www.instagram.com/tribyouplaces?igsh=cDN5NDNwaHJlZWgw" },
];

const SocialsList: FC<SocialsListProps> = ({
  className = "",
  itemClass = "block",
  socials = socialsDemo,
  showLabel = false,
  labelClassName = "hidden lg:block text-sm",
}) => {
  return (
    <nav
      className={`nc-SocialsList flex space-x-2.5 text-2xl text-neutral-6000 dark:text-neutral-300 ${className}`}
      data-nc-id="SocialsList"
    >
      {socials.map((item, i) => (
        <a
          key={i}
          className={`${itemClass}`}
          href={item.href}
          target="_blank"
          rel="noopener noreferrer"
          title={item.name}
        >
          <i className={item.icon}></i>
          {showLabel && <span className={labelClassName}>{item.name}</span>}
        </a>
      ))}
    </nav>
  );
};

export default SocialsList;
